import { render, staticRenderFns } from "./DebugButtons.vue?vue&type=template&id=35d5bd2e&"
import script from "./DebugButtons.vue?vue&type=script&lang=js&"
export * from "./DebugButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports